export function generateAlphabetLinks({ startLetter, endLetter, baseUrl }) {
  const alphabetLinks = [];
  for (let letterCode = startLetter.charCodeAt(0); letterCode <= endLetter.charCodeAt(0); letterCode++) {
    const letter = String.fromCharCode(letterCode);
    const link = `${baseUrl}/${letter}`;
    alphabetLinks.push({ letter: letter, link: link });
  }
  return alphabetLinks;
}